import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "matrivon_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export async function submitEnquiry(payload) {
  const { data } = await http.post("/contact", payload);
  return data;
}

export async function subscribeNewsletter(email, source = "website") {
  const { data } = await http.post("/newsletter", { email, source });
  return data;
}

export function trackEvent(event, label, meta) {
  try {
    http.post("/analytics/event", {
      event,
      label,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      meta,
    });
  } catch (e) {
    /* non-blocking */
  }
}

// ---- Auth / admin ----
export async function adminLogin(email, password) {
  const { data } = await http.post("/auth/login", { email, password });
  setToken(data.token);
  return data.user;
}

export async function fetchMe() {
  const { data } = await http.get("/auth/me");
  return data;
}

export async function fetchAdminStats() {
  const { data } = await http.get("/admin/stats");
  return data;
}

export async function fetchEnquiries() {
  const { data } = await http.get("/admin/enquiries");
  return data;
}

export async function deleteEnquiry(id) {
  const { data } = await http.delete(`/admin/enquiries/${id}`);
  return data;
}

export async function fetchSubscribers() {
  const { data } = await http.get("/admin/subscribers");
  return data;
}

export async function deleteSubscriber(id) {
  const { data } = await http.delete(`/admin/subscribers/${id}`);
  return data;
}

// ---- Gated report downloads ----
export async function submitReportLead(payload) {
  const { data } = await http.post("/report-lead", payload);
  return data;
}

export function reportDownloadUrl(relativeUrl) {
  return `${BACKEND_URL}${relativeUrl}`;
}

export function reportFileUrl(slug) {
  return `${BACKEND_URL}/api/reports/${slug}/download`;
}

export async function fetchReportLeads() {
  const { data } = await http.get("/admin/report-leads");
  return data;
}

export async function deleteReportLead(id) {
  const { data } = await http.delete(`/admin/report-leads/${id}`);
  return data;
}
